/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import { Transition } from '@headlessui/react';
import { useLocation } from 'react-router-dom';

import Button from '../elements/Button';
import BrandIcon from './BrandIcon';

export default function Header() {
  const [isCollapse, setIsCollapse] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 bg-blue-100 transition-all duration-300 ${
        isScrolled ? 'py-2 shadow-md' : 'py-5'
      }`}
    >
      <div className="max-w-screen-xl mx-auto flex items-center justify-between px-4 lg:px-0 transition-all duration-300">
        {/* Brand / Logo */}
        <div className="transition-all duration-300">
          <BrandIcon />
        </div>

        {/* Mobile Toggle */}
        <button
          className="block text-theme-blue lg:hidden focus:outline-none"
          onClick={() => setIsCollapse(!isCollapse)}
        >
          <svg
            className="w-8 h-8"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              className={`${isCollapse ? 'hidden' : 'block'}`}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
            <path
              className={`${!isCollapse ? 'hidden' : 'block'}`}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Desktop Nav */}
        <ul className="hidden lg:flex items-center text-theme-blue tracking-widest">
          <li>
            <Button
              className={`${path === '/' ? 'active-link' : ''} font-medium text-lg px-5 hover:underline`}
              type="link"
              href="/"
            >
              Home
            </Button>
          </li>
          <li>
            <Button
              className={`${path === '/about' ? 'active-link' : ''} font-medium text-lg px-5 hover:underline`}
              type="link"
              href="/about"
            >
              About Us
            </Button>
          </li>
          <li>
            <Button
              className={`${path === '/service' ? 'active-link' : ''} font-medium text-lg px-5 hover:underline`}
              type="link"
              href="/service"
            >
              Our Services
            </Button>
          </li>
          <li>
            <Button
              className={`${path === '/gallery' ? 'active-link' : ''} font-medium text-lg px-5 hover:underline`}
              type="link"
              href="/gallery"
            >
              Gallery
            </Button>
          </li>
          <li>
            <Button
              className="ml-3 px-6 py-2 bg-theme-purple text-white rounded-full border-2 border-theme-purple hover:bg-dark-theme-purple transition duration-200"
              type="link"
              href="/discuss-project"
            >
              Discuss Project
            </Button>
          </li>
        </ul>
      </div>

      {/* Mobile Menu */}
      <Transition
        show={isCollapse}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <ul className="z-50 flex flex-col text-theme-blue tracking-widest my-4 absolute bg-white w-full border-b-2 border-gray-300 lg:hidden">
          <li className="py-2">
            <Button className="px-10" type="link" href="/">
              Home
            </Button>
          </li>
          <li className="py-2">
            <Button className="px-10" type="link" href="/about">
              About
            </Button>
          </li>
          <li className="py-2">
            <Button className="px-10" type="link" href="/service">
              Services
            </Button>
          </li>
          <li className="py-2">
            <Button className="px-10" type="link" href="/gallery">
              Gallery
            </Button>
          </li>
          <li className="py-4 text-center">
            <Button
              className="font-bold px-6 py-2 bg-theme-purple text-white rounded-full border-2 border-theme-purple hover:bg-dark-theme-purple transition duration-200"
              type="link"
              href="/discuss-project"
            >
              Discuss Project
            </Button>
          </li>
        </ul>
      </Transition>
    </header>
  );
}
